import React from 'react';

import Bracket from './Bracket';
import JsonLogicBuilder from './index';
import Divider from './Divider';
import Delete from './Delete';

const operators = [
  {value: '==', label: '='},
  {value: '!=', label: '≠'},
  {value: '>=', label: '≥'},
  {value: '<=', label: '≤'},
  {value: '>', label: '>'},
  {value: '<', label: '<'},
  {value: 'in', label: 'in'},
  {value: 'search_list', label: 'Contains'}
];

function CompareExpression({variables, operator, value, onChange, onCollapse}) {
  const rightOption = (value[0] && !!value[0].var && variables[value[0].var]) ? variables[value[0].var].options : [];
  const leftOption = (value[1] && !!value[1].var && variables[value[1].var]) ? variables[value[1].var].options : [];

  return (
    <Bracket onCollapse={onCollapse}>
      <JsonLogicBuilder
        expand
        variables={variables}
        options={leftOption}
        value={value[0]}
        onChange={nextValue => onChange({[operator]: [nextValue, value[1]]})}
      />
      <Divider />
      <ComparisonSelector
        variables={variables}
        value={operator}
        onChange={nextOperator => onChange({[nextOperator]: value})}
      />
      <Delete onClick={() => onChange(null)} />
      <Divider />
      <JsonLogicBuilder
        expand
        variables={variables}
        value={value[1]}
        options={rightOption}
        onChange={nextValue => onChange({[operator]: [value[0], nextValue]})}
      />
    </Bracket>
  );
}

function ComparisonSelector({value, onChange}) {
  return (
    <select value={value} onChange={e => onChange(e.target.value)}>
      {operators.map(operator => (
        <option key={operator.value} value={operator.value}>
          {operator.label}
        </option>
      ))}
    </select>
  );
}

export default CompareExpression;
